import {
  CRUDLayout
} from "components"
import {
  ButtonCreate,
  ButtonFilter,
  DataStatus,
  InputSearch
} from "components2"
import { Formik } from "formik"
import { debounce } from "lodash"
import { useEffect, useState } from "react"
import { useQuery } from "react-query"
import { useHistory } from "react-router-dom/cjs/react-router-dom.min"
import { GuestMiddleware } from "utilities"
import PermintaanPerubahanDataApi from "./api/PermintaanPerubahaDataApi"
import { ModalFilterListPermintaanPerubahanData } from "./components"
import { ListPermintaanPerubahanData } from "./components/ListPermintaanPerubahanData"

export const PermintaanPerubahaDataList = ({ setNavbarTitle }) => {
  const history = useHistory()
  const [pagination, setPagination] = useState({
    q: "",
    page: 1,
    per_page: 10
  })

  const [filter, setFilter] = useState({
    tgl_mulai: undefined,
    tgl_selesai: undefined,
    urgensi: undefined,
    active: false
  })

  const [modalFilter, setModalFilter] = useState(false)

  const getPermintaanPerubahanData = useQuery(
    ["pengajuan_petty_cash", "list", pagination, filter],
    () => PermintaanPerubahanDataApi.getList({ ...pagination, ...filter })
  )

  const searchHandler = (e) => {
    const searchKey = e.target.value ? e.target.value : undefined

    setPagination({
      ...pagination,
      q: searchKey
    })
  }

  const onFilterButtonClickkHandler = () => setModalFilter(!modalFilter)

  const onDetailButtonClickHandler = (data) => history.push(`/rqm/support/permintaan-pengubahan-data/detail/${data?.id_permintaan_perubahan_data_master}`)

  const onPaginationChange = ({ selected }) => setPagination({ ...pagination, page: selected + 1 })

  const onPaginationDataLengthChange = (e) => setPagination({ ...pagination, page: 1, per_page: e.target.value })

  const formInitialValuesFilter = {
    tgl_mulai: filter?.tgl_mulai,
    tgl_selesai: filter?.tgl_selesai,
    urgensi: filter?.urgensi,
  }

  const formSubmitHandlerFilter = (values) => {
    const checkActive =
      !!Object.values(values).filter((val) => val !== undefined).length > 0

    setFilter({
      ...filter,
      ...values,
      active: checkActive,
      page: 1
    })
    onFilterButtonClickkHandler()
  }

  useEffect(() => setNavbarTitle("Permintaan Pengubahan Data"), [])

  return (
    <CRUDLayout>
      <CRUDLayout.Head>
        <CRUDLayout.HeadSearchSection>
          <div className="d-flex mb-0">
            <InputSearch
              onChange={debounce(searchHandler, 1500)}
              className="mr-2"
            />
            <ButtonFilter
              size="sm"
              className="text-nowrap"
              onClick={onFilterButtonClickkHandler}
              active={filter?.active}
            />
          </div>
        </CRUDLayout.HeadSearchSection>
        <CRUDLayout.HeadButtonSection></CRUDLayout.HeadButtonSection>
      </CRUDLayout.Head>

      {getPermintaanPerubahanData.isLoading || getPermintaanPerubahanData.isError ? (
        <DataStatus
          loading={getPermintaanPerubahanData.isLoading}
          text={
            getPermintaanPerubahanData.isLoading
              ? "Memuat . . ."
              : "Data gagal dimuat"
          }
        />
      ) : (
        <ListPermintaanPerubahanData
          getPermintaanPerubahanDataList={getPermintaanPerubahanData}
          onDetailButtonClickHandler={onDetailButtonClickHandler}
          onPaginationChange={onPaginationChange}
          onPaginationDataLengthChange={onPaginationDataLengthChange}
          pagination={pagination}
        />
      )}

      <Formik
        enableReinitialize
        initialValues={formInitialValuesFilter}
        onSubmit={formSubmitHandlerFilter}
      >
        <ModalFilterListPermintaanPerubahanData
          isToggle={modalFilter}
          toggle={onFilterButtonClickkHandler}
        />
      </Formik>
    </CRUDLayout >
  )
}
